export default (items: any[]): any => {
    return Object.assign({}, ...items.map(item => ({[item.id]: {...item, id: undefined}})));
};
